// bazaarui — am. Bazaar/Market page chrome: product detail, cart, checkout,
// delivery, seller store, product card, and the shared buy-flow labels.

export default {
  // ProductCard
  cardSold: (n) => `${n} ተባርቷል`,
  cardBundle: 'ጥቅል',
  cardOnlyLeft: (n) => `${n} ብቻ ቀርቷል`,
  cardColorsTitle: (c) => `ያለውት ቀለሞች: ${c}`,
  cardAllColorsTitle: 'በሁሉም ቀለሞች ይገኛል',
  cardColorsCount: (n) => `${n} ቀለሞች`,

  // ProductDetailPage
  pdWishlistToast: '... ወደ ዝልይት ተጨምሯል!',
  pdLinkCopied: 'አገናኝ ወደ ቅጂ ተቀድቷል!',
  pdNotFound: 'ምርት አልተገኘም',
  pdBrowseBazaar: 'የሽያጭ ቦታን ይመልከቱ',
  pdSignInTitle: 'መግባት ያስፈልጋል',
  pdSignInDesc: 'ወደ ዝልይትዎ ጥቆች ለማስገባት መግባት ያስፈልጋል።',
  pdSignInCta: 'ግባ',
  pdRegisterBuyer: 'እንደ ገዢ ተመዝግበህ ይመዝግቡ',
  pdCancel: 'ሰርዝ',
  pdSoldOut: 'ተሽይ኷ል',
  pdOffPct: (p) => `${p}% ቅናሽ`,
  pdShare: 'አጋራ',
  pdAvailableColors: 'ያሉት ቀለሞች',
  pdAllColors: 'ሁሉም ቀለሞች',
  pdOnlyLeft: (n) => `${n} ብቻ ቀርቷል!`,
  pdLikeLabel: 'ይህን ምርት ተመልክት',
  pdLikeAction: 'ተመልክት',
  pdUnlike: 'ተመልክት አስወግድ',
  pdLikeOne: 'ተመልክት',
  pdLikes: 'ተመልክቶች',
  pdViewOne: 'እይታ',
  pdViews: 'እይታዎች',
  pdDescription: 'መግለጫ',
  pdNoDescription: 'መግለጫ አልተሰጠም።',
  pdWhatsIncluded: 'ምን ይካት',
  pdSoldBy: 'የሚሸጥበት',
  pdStore: 'መደቤ',
  pdQuantity: 'ብዛት',
  pdSubtotal: 'ንዑስ ድምር',
  pdAddToWishlist: 'ወደ ዝልይት ጨምር',
  pdAddedToWishlist: 'ወደ ዝልይት ተጨምሯል',
  pdChatWithSeller: 'ከሻሻዩ ጋር ያናግሩ',
  pdDeliveryTitle: 'ማድረስ',
  pdDeliveryDesc: 'በቀጥታ ከሻሻዩ',
  pdSecureTitle: 'ደህንነቱ የተጠበቀ',
  pdSecureDesc: 'የተረጋግጠ ክፍያ',
  pdAuthenticTitle: 'ወጥ',
  pdAuthenticDesc: 'የተረጋግጠ ሻሽላት',

  // CartPage
  cartEmptyTitle: 'ዝልይትዎ ባዶ ነው',
  cartEmptyDesc: 'እስካሁን ምንም አላስቀምጥዎም።',
  cartBrowse: '← የሽያጭ ቦታን ይመልከቱ',
  cartBack: '← ወደ ሽያጭ ቦታ ተመለስ',
  cartTitle: 'ዝልይትዎ',
  cartStore: 'መደቤ፦',
  cartItems: '📦 ጥቆች',
  cartUnit: 'የአካል ዋጋ፦',
  cartDecrease: 'ብዛት ቀንስ',
  cartIncrease: 'ብዛት ጨምር',
  cartRemoveItem: 'ጥቆውን አስወግድ',
  cartTotal: 'የዝልይት ጠቅላላ',

  sellerContactTitle: 'የሻጭ አግኙት',
  sellerContactHint: 'ይህን ቁጥር በቀጥታ ለሻጭ መደርደር አስቀምጥ።',
  sellerContactTelegram: 'በቴሌግራም ደውል',

  // SellerStorePage
  spSignInToSave: 'ለማስቀመጥ መግባት ያስፈልጋል',
  spNoProducts: 'ምንም ምርት ከዚህ ሻሽላት አልተገኘም',
  spVerifiedSeller: 'የተረጋግጠ All Things የሽያጭ ቦታ ሻሽላት',

  // CheckoutPage
  coTitle: 'ክፍያ',
  coFastYango: 'በYango ፈጣን የሞትሪሳይክል ማድረስ',
  coYangoDesc: 'የሞትሪሳይክል አገልግሎት',
  coRideDesc: 'የRide የሞትሪሳይክል አገልግሎት',
  coGlovo: 'Glovo',
  coGlovoDesc: 'በጥያቄ የሚደርስ ማድረስ',
  coLalamove: 'Lalamove',
  coLalamoveDesc: 'በቀኑ የሚደርስ ኮሪየር',
  coOtherCourier: 'ሌላ ኮሪየር',
  coOtherCourierDesc: 'የአካባቢ ኮሪየር',
  coPickup: 'ማድረስ የለም (ራስህ ይውሳድ)',
  coPickupDesc: 'ትዕዛዙን ራስህ እንውሳለህ',
  coDelivery: 'ማድረስ',
  coPayment: 'ክፍያ',
  coSelectPlaceholder: 'እባክዎ ይምረጡ...',
  coSelectShort: 'ይምረጡ...',
  coSelectDelivery: 'እባክዎ የማድረስ አማራጭ ይምረጡ።',
  coDeliveryIntro: 'በኢትዮጵያ ትዕዛዙን በሚችሉበት መንገድ ይምረጡ።',
  coSuccessTitle: 'ትዕዛዙ ተሳክቷል!',
  coOrderId: 'የትዕዛዝ መለያ፦',
  coDeliveryVia: 'በማድረስ፦',
  coBackToBazaar: 'ወደ ሽያጭ ቦታ ተመለስ',
  coOrderSummary: 'የትዕዛዝ ማጠቃለያ',
  coQty: 'ብዛት፦',
  coTotal: 'ጠቅላላ',
  coChooseDelivery: 'የማድረስ ዘዴን ይምረጡ',
  coContinuePayment: 'ወደ ክፍያ ቀጥል',
  coDeliveryMethod: 'የማድረስ ዘዴ',
  coChange: 'ቀይር',
  coTransferTo: 'ወደ ይላኩ፦',
  coPaymentProof: 'የክፍያ ማረጋገጫ',

  // DeliveryPage
  dlReceivedTitle: 'ጥያቄው ደርሷል!',
  dlRequestId: 'የማድረስ ጥያቄ መለያ፦',
  dlBackToBazaar: '← ወደ ሽያጭ ቦታ ተመለስ',
  dlOrderNum: 'ትዕዝት #',

  // BazaarPage / MarketPage
  bzOpensIn: 'ይከፈታል በ',
  bzHeroTitle: 'ባዛር',
  bzHeroDesc: 'ከተረጋገጡ የኢትዮጵያ ሻጮች ይግዙ — በእጅ የተሰሩ እቃዎች፣ ፋሽን፣ ምግብ እና ሌሎችም።',
  bzSaveEtb: 'ይቆጥቡ ETB',
  bzInStockOnly: 'በክምችት ውስጥ ብቻ',
  bzClearFilters: 'ሁሉንም ማጣሪያዎች ንጹ',
};